import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { useMutation } from '@tanstack/react-query';
import { pathgen } from 'object-path-generator';
import { useOverlayContext } from 'seagull';
import { useStoreActions } from '~/contexts';
export const useArchiveDraftTestIds = pathgen('useArchiveDraftTestIds');
const MutationName = 'useMutationState';
export const useMutationStateTestIds = pathgen('useMutationStateTestIds');
export const useMutationState = (options)=>{
    const { withPageLoader, mutationName, biCode, toasts } = options, rest = _object_without_properties(options, [
        "withPageLoader",
        "mutationName",
        "biCode",
        "toasts"
    ]);
    const { startLoader, stopLoader, showSuccessToast, showErrorToast } = useOverlayContext();
    const { logBI } = useStoreActions();
    const mutation = useMutation(_object_spread_props(_object_spread({}, rest), {
        onMutate: function onMutate() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var _options_onMutate;
            if (withPageLoader) {
                startLoader(mutationName !== null && mutationName !== void 0 ? mutationName : MutationName);
            }
            if (biCode) {
                logBI(biCode);
            }
            (_options_onMutate = options.onMutate) === null || _options_onMutate === void 0 ? void 0 : _options_onMutate.call(options, ...args);
        },
        onSettled: function onSettled() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var _options_onSettled;
            if (withPageLoader) {
                stopLoader(mutationName !== null && mutationName !== void 0 ? mutationName : MutationName);
            }
            (_options_onSettled = options.onSettled) === null || _options_onSettled === void 0 ? void 0 : _options_onSettled.call(options, ...args);
        },
        onSuccess: function onSuccess() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var _options_onSuccess;
            if (toasts === null || toasts === void 0 ? void 0 : toasts.successMessage) {
                var _toasts_successTestId;
                showSuccessToast(toasts.successMessage, (_toasts_successTestId = toasts.successTestId) !== null && _toasts_successTestId !== void 0 ? _toasts_successTestId : useMutationStateTestIds.SuccessToast());
            }
            (_options_onSuccess = options.onSuccess) === null || _options_onSuccess === void 0 ? void 0 : _options_onSuccess.call(options, ...args);
        },
        onError: function onError() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var _options_onError;
            if (toasts === null || toasts === void 0 ? void 0 : toasts.errorMessage) {
                var _toasts_errorTestId;
                showErrorToast(toasts.errorMessage, (_toasts_errorTestId = toasts.errorTestId) !== null && _toasts_errorTestId !== void 0 ? _toasts_errorTestId : useMutationStateTestIds.ErrorToast());
            }
            (_options_onError = options.onError) === null || _options_onError === void 0 ? void 0 : _options_onError.call(options, ...args);
        }
    }));
    return mutation;
};
